module.exports = __webpack_public_path__ + "img/6.e25a0092.svg";